import { render } from "./OnlineCareRequest.vue?vue&type=template&id=8aadfd04&scoped=true&ts=true"
import script from "./OnlineCareRequest.vue?vue&type=script&lang=ts"
export * from "./OnlineCareRequest.vue?vue&type=script&lang=ts"

import "./OnlineCareRequest.vue?vue&type=style&index=0&id=8aadfd04&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aadfd04"]])

export default __exports__